import { HTTPClient } from '../utils/request'

export default {
  get: () => HTTPClient.get(`/group`),
  store: ({ payload }) => HTTPClient.post(`/group`, payload),
  attach: ({ params, payload }) =>
    HTTPClient.post(`/group/${params._id}/attach`, payload)
}
